<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="1"
            horizontal>
            <b-form-input id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="clientesContactos" 
            :fields="clientesContactosFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarContacto">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'ClientesContactos',
  props: {
    cliente: {
      type: Object,
      default: null
    },
  },
  data: () => {
    return {
      clientesContactos: [],
      clientesContactosFields: [],

      loaded: false,
      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      clienteId: 0,
      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.clienteId = 0;
    if (this.cliente) {
      if (this.cliente.id) {
        this.clienteId = this.cliente.id;
      }
    }

    if (this.clienteId != 0) {
      this.clientesContactosFields = [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'nombre',
          label: 'Contacto',
          sortable: true
        },
      ]
    } else {
      this.clientesContactosFields = [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'cliente',
          label: 'Cliente',
          sortable: true
        },
        {
          key: 'nombre',
          label: 'Contacto',
          sortable: true
        },
      ]
    }


    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('clientescontactos/getClientesContactosList', this.clienteId)
        .then(() => {
          this.clientesContactos = this.$store.getters['clientescontactos/contactosList'];
          this.totalRegistros = this.clientesContactos.length;
          this.tableBusy = false;
        })
    },
    seleccionarContacto (item) {
      this.$emit('contactoSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
</style>
